export default __webpack_public_path__ + "static/media/newzealand-flag.5aa62eb3.png";